import React from "react";
import { useLocation } from "react-router-dom";
import Routes from "./index";
import { TourProvider } from "../store/coach-mark-context";
import {CurrencyProvider} from "../store/currency-selector-context";

const RoutesWrapper: React.FC = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  return (
    <div className={`${isLandingPage}`}>
      <CurrencyProvider>
        <TourProvider>
          <Routes />
        </TourProvider>
      </CurrencyProvider>
    </div>
  );
};

export default RoutesWrapper;
